import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { asNumber } from '@frontend/unhideschool/app/helpers/utility-functions';
import { NormalizedPlanBaseModel } from '@frontend/unhideschool/modules/membership/models/membership-normalized-plan.model';
import { UNHMembershipPrincingTranslation, UNHPriceBoxTeamTranslation } from '@frontend/unhideschool/app/utils/i18n/locale/unh-membership-pricing/unh-membership-pricing.i18n.model';
import { UseTranslations } from '@frontend/unhideschool/app/utils/i18n/use-translation.decorator';

interface Translations {
  "unh-membership-pricing": UNHMembershipPrincingTranslation;
}


@Component({
  selector: 'unh-price-box',
  templateUrl: './price-box.component.html',
  styleUrls: ['./price-box.component.scss']
})

@UseTranslations({
  translatableComponents : ["unh-membership-pricing"]
})

export class PriceBoxComponent{
  private _plan: NormalizedPlanBaseModel;
  private minQtyArtists = 5;

  multipleTotalPrice = 0;
  qtyTeamArtists = this.minQtyArtists;

  monthlyplanprice = 108;

  @Output() checkoutClicked = new EventEmitter();
  @Input() multiple: boolean;
  @Input() ispro: boolean;
  @Input() showRenewButton: boolean;
  @Input() activePromo: boolean;

  membershipPricingMock : UNHMembershipPrincingTranslation;
  priceBoxTeamMock : UNHPriceBoxTeamTranslation;
  translations: Promise<Translations>;

  @Input()
  set plan(val: NormalizedPlanBaseModel) {
    this._plan = val;
    if (this.plan != null) {
      const price = this.plan.price;
      this.multipleTotalPrice = this.getTotalPrice(price, this.qtyTeamArtists);
    }
  }

  get plan() {
    return this._plan;
  }

  @ViewChild('qtyartists', { static: false }) qtyartistsElementRef: ElementRef<HTMLInputElement>;

  onChangeQtyArtist(inputEl: HTMLInputElement, price: number) {
    let inputValue = inputEl.value;

    if (inputValue == null || inputValue === '' || asNumber(inputValue) < 5) {
      this.qtyTeamArtists = 5;
      inputValue = this.qtyTeamArtists.toString();
    }

    const val = inputValue.replace(/[^0-9]+/g, '');
    const qty = parseInt(val, 10);
    this.multipleTotalPrice = this.getTotalPrice(price, qty);
  }

  resetInputQtyartists(inputEl: HTMLInputElement) {
    let inputValue = inputEl.value;

    if (inputValue == null || inputValue === '' || asNumber(inputValue) < 5) {
      const pos = inputEl != null ? inputEl.selectionStart : 0;
      inputEl.value = (this.qtyTeamArtists = this.minQtyArtists).toString();
      inputEl.selectionStart = inputEl.selectionEnd = pos - 1;
    }
  }

  onClickToCheckout() {
    const quantity = this.multiple ? this.qtyTeamArtists : 1;
    this.checkoutClicked.emit({ plan: this.plan, qty: quantity });
  }

  private getTotalPrice(price: number, qty: number) {
    return price * (qty - (Math.floor(qty / 5)));
  }

  ngOnInit(): void {
    this.translations.then((translations) => {
      this.membershipPricingMock = translations['unh-membership-pricing'];
    })
  }

}
